/** Normalize unicode quotes and degree symbols before parsing. */
export function normalizeCoordinateInput(input: string): string {
  if (!input) {
    return '';
  }
  return input
    .trim()
    .replace(/[\u2018\u2019\u2032]/g, "'")
    .replace(/[\u201C\u201D\u2033]/g, '"')
    .replace(/\u00B0/g, '°')
    .replace(/\s+/g, ' ')
    .trim();
}
